import React from 'react'

function HorizontalScrollChild({ children }) {
  return (
    <div className="flex-none w-3/4 md:w-auto md:flex-1 overflow-hidden">
      {children}
    </div>
  )
}

export default HorizontalScrollChild
